import React from 'react';
import ReactTooltip from 'react-tooltip';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useMediaQuery } from 'react-responsive';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  tooltip: {
    ...theme.fonts.label,
    maxWidth: theme.marginBase * 50,
    padding: [[theme.marginBase, theme.marginBase * 3]],

    minHeight: theme.height.small,
    display: 'flex',
    alignItems: 'center',

    '&.type-dark': {
      backgroundColor: theme.colors.inkPrimary,
      color: theme.colors.white,

      '&.place-bottom::after': {
        borderBottomColor: theme.colors.inkPrimary,
      },
      '&.place-top::after': {
        borderTopColor: theme.colors.inkPrimary,
      },
      '&.place-right::after': {
        borderRightColor: theme.colors.inkPrimary,
      },
      '&.place-left::after': {
        borderLeftColor: theme.colors.inkPrimary,
      },
    },
    '&.show': {
      opacity: 1,
    },
  },
}));

export const NAVBAR_TOOLTIP_ID = 'NAVBAR_TOOLTIP_ID';

const offset = { right: 16 };
const mobileOffset = { bottom: 16 };

export const NavbarTooltip = () => {
  const theme: Theme = useTheme() as Theme;
  const classes = useStyles({ theme });

  const isMobile = useMediaQuery({ query: theme.mediaContent.mobile });

  return (
    <ReactTooltip
      effect="solid"
      place={isMobile ? 'top' : 'right'}
      offset={isMobile ? mobileOffset : offset}
      border={false}
      className={classes.tooltip}
      id={NAVBAR_TOOLTIP_ID}
    />
  );
};
